import { createContext, type PropsWithChildren } from 'react';

/**
 * @internal
 * Context providing enabled new interaction pattern feature.
 */
export const DataTableV2CellInteractionPatternFeature = createContext(false);

/**
 * @public
 * Feature provider for the new interaction pattern of the DataTableV2 cell interactions.
 */
export function DataTableV2CellInteractionPattern(props: PropsWithChildren) {
  return (
    <DataTableV2CellInteractionPatternFeature.Provider value={true}>
      {props.children}
    </DataTableV2CellInteractionPatternFeature.Provider>
  );
}
